import React, { useState, useRef, useEffect } from 'react';
import ReportsMemberTable from './ReportsMembersTable';
import LinearProgressWithLabel from './ui/progress';
import { AnsweredQuestions, Cohort, Member } from '@/utils/types';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import InviteMember from './InviteMember';
import ImportGroup from './ImportGroup';

interface reportsScreenProps {
    cohorts: Cohort[],
    error: boolean
    setoverlayComp: (val: boolean) => void
    setResultOverlayComp: (text: string | null) => void
}

export default function ReportsScreen(props: reportsScreenProps) {
    const [members, setmembers] = useState<Member[]>([]);

    useEffect(() => {
        const mems = props.cohorts.map(c => c.members).reduce((acc, curr) => acc.concat(curr), []);
        setmembers(mems.filter(m => m.membershipType === "student" && m.id !== null));
    }, [props.cohorts]);

    return (
        <div className='flex-col items-start justify-start'>
            <div className='flex-col items-start justify-start w-[100%] mb-3'>
                <p className="text-grayBlue text-4xl mb-2 font-[600]">Reports</p>
                <div className="flex justify-between  w-[100%]">
                    <p className='text-left w-[60%]'>This page allows admins to download reports of the organization.</p>
                </div>
            </div >

            <ReportsMemberTable
                members={members}
                error={props.error}
                setoverlayComp={props.setoverlayComp} />
        </div>
    );
}